@charset "utf-8";
@import "variables.scss";
@import "bulma/bulma";
@import "partials/partials.scss";
@import "partials/table";
@import "bulma-switch";
@import "multiselect";
@import "floating-vue/dist/style.css";
@import "general.scss";
